import { PathLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { toExternalModuleUrl, toInternalModuleUrl } from '@rcs/utils';

@Injectable()
export class ModuleUrlAliasLocationStrategy extends PathLocationStrategy {
  override path(includeHash = false): string {
    return toInternalModuleUrl(super.path(includeHash));
  }

  override prepareExternalUrl(internal: string): string {
    return super.prepareExternalUrl(toExternalModuleUrl(internal));
  }
}
